/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VendorCreate } from '../models/VendorCreate';
import type { VendorRead } from '../models/VendorRead';
import type { VendorUpdate } from '../models/VendorUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VendorsService {
    /**
     * List Vendors
     * @returns VendorRead Successful Response
     * @throws ApiError
     */
    public static listVendorsVendorsGet(): CancelablePromise<Array<VendorRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vendors/',
        });
    }
    /**
     * Create Vendor
     * @returns VendorRead Successful Response
     * @throws ApiError
     */
    public static createVendorVendorsPost({
        requestBody,
    }: {
        requestBody: VendorCreate,
    }): CancelablePromise<VendorRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/vendors/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Vendor
     * @returns VendorRead Successful Response
     * @throws ApiError
     */
    public static getVendorVendorsVendorIdGet({
        vendorId,
    }: {
        vendorId: number,
    }): CancelablePromise<VendorRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vendors/{vendor_id}',
            path: {
                'vendor_id': vendorId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Vendor
     * @returns VendorRead Successful Response
     * @throws ApiError
     */
    public static updateVendorVendorsVendorIdPatch({
        vendorId,
        requestBody,
    }: {
        vendorId: number,
        requestBody: VendorUpdate,
    }): CancelablePromise<VendorRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/vendors/{vendor_id}',
            path: {
                'vendor_id': vendorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Vendor
     * @returns void
     * @throws ApiError
     */
    public static deleteVendorVendorsVendorIdDelete({
        vendorId,
    }: {
        vendorId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/vendors/{vendor_id}',
            path: {
                'vendor_id': vendorId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
